export default __webpack_public_path__ + "static/media/BM_RenderCamera_03_LivingC+Interior+Light_Scheme+Living.94acb993.jpg";